import {AddAddressView} from "./addAddressView";
import {IPresenter} from "@/rawdogjs/src/interfaces/IPresenter";
import {ParcelDependencyContainer} from "@/rawdogjs/src/core/ParcelDependencyContainer";
import {Router} from "@/rawdogjs/src/router";
import {ErrorBase} from "@/rawdogjs/src/core/ErrorBase";
import {LoadingPresenter} from "../../loading/loadingPresenter";
import {BookingStore} from "../../../data/stores/BookingStore";
import {RenderComponent} from "@/rawdogjs/src/renderRoute";
import {BookingApi} from "../../../services/api/base/BookingApi";
import {UserStore} from "../../../data/stores/UserStore";
import {ValidationError} from "@/rawdogjs/src/core/ValidationError";
import {UuidHelper} from "../../../shared/IdentityHelper";


export class AddAddressPresenter implements IPresenter {

    public _view: AddAddressView;
    private _dependencyContainer: ParcelDependencyContainer;
    private readonly _router: Router;
    private _errors: ErrorBase[] = [];
    private _serverErrors: ErrorBase[] = [];
    private _loading: LoadingPresenter;
    private _bookingStore: BookingStore;

    constructor(addAddressView: AddAddressView, router: Router, dependencyContainer: ParcelDependencyContainer) {
        this._view = addAddressView;
        this._router = router;
        this._dependencyContainer = dependencyContainer;
    }

    async initialize() {

        const renderComponent = new RenderComponent(this._router);
        this._loading = await renderComponent.render<LoadingPresenter>('loading');
        this._view.$element.append(this._loading._view.$element);


   

        this._view.bind(
            this,
            async (fieldSelector, value, fieldName) => {
                await this.handleFormChange(fieldSelector, value, fieldName);
            }
        );


        this._bookingStore = this._dependencyContainer.resolve<BookingStore>('BookingStore');

        await this.initializeBookingStore();
        
        this.loadForm();

       

        setTimeout(
            () => this._view.focusOnElement('street-address-one'),
            1000
        );
        
    }

    async initializeBookingStore() {
        this._loading.setBody('Loading data...');
        this._loading.show(true);

        await this._bookingStore.pull();

        this._loading.show(false);
    }

    loadForm() {
        const existingBooking = this._bookingStore.getBooking();

        if (existingBooking?.address) {
            this._view.streetAddressOne = existingBooking.address.streetAddressOne;
            this._view.streetAddressTwo = existingBooking.address.streetAddressTwo;
            this._view.city = existingBooking.address.city;
            this._view.zipPostalCode = existingBooking.address.zipPostalCode;
            this._view.stateProvinceRegion = existingBooking.address.stateProvinceRegion;
        }
    }

    getCombinedErrors() {
        return this._errors.concat(this._serverErrors);
    }

    async handleFormChange(fieldSelector: string, value: string, fieldName: string) {
        // validate and then set the field errors
        await this.validate();
        this._view.setFieldErrors(this.getCombinedErrors(), fieldName);
    }

    async submit() {

        const api = this._dependencyContainer.resolve<BookingApi>('BookingApi');
        const userStore = this._dependencyContainer.resolve<UserStore>('UserStore');

        this._loading.setBody('Loading...');
        this._loading.show(true);


        try {
            const result = await api.post(
                {
                    addAddress: {
                        streetAddressOne: this._view.streetAddressOne,
                        streetAddressTwo: this._view.streetAddressTwo,
                        city: this._view.city,
                        stateProvinceRegion: this._view.stateProvinceRegion,
                        zipPostalCode: this._view.zipPostalCode,
                        country: 'US'
                    }
                },
                userStore.getParentTenant(),
                true,
                false
            );

            if (result.data?.errors && result.data.errors.length > 0) {
                this._view.setErrorList(result.data.errors)
            }

            if (result.data?.id) {

                this._loading.setBody('Loading...');
                this._loading.show(true);
                await this._bookingStore.pull();
                this._loading.show(false);

                // successful response 
                this._router.navigate('/#/drywallio/contact')
            }

        } catch (e) {
            alert('Server error.' + e.toString());
        } finally {
            this._loading.show(false);
        }

    }

    async validate() {

        this._errors = [];

        if (!this._view.streetAddressOne) {
            this._errors.push(
                new ValidationError(
                    UuidHelper.newId(),
                    'Street Address cannot be empty.',
                    'addAddressPresenter.StreetAddressCannotBeEmpty',
                    '026bf419-d935-44f6-8927-d97b78d14252',
                    'streetAddressOne'
                )
            )
        }

        if (!this._view.city) {
            this._errors.push(
                new ValidationError(
                    UuidHelper.newId(),
                    'City cannot be empty.',
                    'addAddressPresenter.CityCannotBeEmpty',
                    '',
                    'city'
                )
            )
        }

        if (!this._view.zipPostalCode) {
            this._errors.push(
                new ValidationError(
                    UuidHelper.newId(),
                    // todo: change label in the future to support internationalization
                    'Zip cannot be empty.',
                    'addAddressPresenter.ZipPostalCodeCannotBeEmpty',
                    '',
                    'zipPostalCode'
                )
            )
        }

    }

    inject() {
    }


} 

